import { render, staticRenderFns } from "./FrzProductionLine.vue?vue&type=template&id=158b1f37"
import script from "./FrzProductionLine.vue?vue&type=script&lang=js"
export * from "./FrzProductionLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports